module.exports = __webpack_public_path__ + "img/fileDoc.68e0f69f.svg";